var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMarker(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 92,
    viewBox: "0 0 80 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_250_679)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.2977 35.5286C59.2977 44.4792 47.3242 60.2445 42.0026 66.8557C40.7746 68.3814 38.4208 68.3814 37.1927 66.8557C31.8712 60.2445 20 44.4792 20 35.5286C20 24.7472 28.6987 16 39.6489 16C50.4967 16 59.2977 24.7472 59.2977 35.5286Z",
    fill: "#3C86A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8964 26.8203C46.2137 18.9903 32.8105 19.0019 28.1104 26.8203C25.0195 31.6415 26.2338 38.9604 30.8991 42.3759C31.5498 41.1561 32.5839 40.372 33.7633 39.6459C27.8722 34.7027 31.724 23.9509 39.5731 24.2355C45.8709 24.0729 50.2515 31.293 47.4279 36.8868C44.9181 30.4101 35.2041 29.9628 35.2041 36.0329C35.7502 34.6911 37.3944 34.4529 38.5215 35.0338C40.2703 35.9632 39.8113 37.973 38.353 38.943C36.4648 40.1977 33.223 41.2549 32.5026 43.4796C34.7451 42.2423 38.202 41.4233 41.9667 41.3594C44.2383 41.3188 46.3531 41.5511 48.4911 42.0681C52.8543 38.5771 53.8884 31.4905 50.8964 26.8262",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_250_679",
    x: 0,
    y: 0,
    width: 79.2969,
    height: 92,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_250_679"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_250_679",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker);
export default __webpack_public_path__ + "static/media/marker.37e64a2e971e0c8dacc54ecfe1a47d30.svg";
export { ForwardRef as ReactComponent };